export default __webpack_public_path__ + "e1b75e73f02f6d104c88a5b94465602f.png";